<script setup>
import ProductFeedForm from '@frontJs/components/forms/projectManagement/sma/ProductFeedForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const {
    facebookAdsProductFeed,
    facebookAdsProductFeedTypes,
    facebookAdsProductFeedVariables,
    mappingVariableInformation,
    tenant,
    productAttributes,
} = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    facebookAdsProductFeed: {
        type: Object,
        required: false,
    },
    facebookAdsProductFeedTypes: {
        type: Array,
        required: false,
    },
    facebookAdsProductFeedVariables: {
        type: Array,
        required: false,
    },
    mappingVariableInformation: {
        type: Object,
        required: false,
    },
    productAttributes: {
        type: Array,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="facebookAdsProductFeed">
            Mettre à jour le flux produits #{{ facebookAdsProductFeed.id }} -
            Flux produits SMA - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un flux produits - Flux produits - SMA - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle v-if="facebookAdsProductFeed" :tenant-name="tenant.name">
        Gestion de projet - SMA - Flux produits - Mettre à jour le flux produits
        #{{ facebookAdsProductFeed.id }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - SMA - Flux produits - Créer un flux produits
    </PageTitle>

    <ProductFeedForm
        :tenant="tenant"
        :facebook-ads-product-feed="facebookAdsProductFeed"
        :facebook-ads-product-feed-types="facebookAdsProductFeedTypes"
        :facebook-ads-product-feed-variables="facebookAdsProductFeedVariables"
        :mapping-variable-information="mappingVariableInformation"
        :product-attributes="productAttributes"
    />
</template>
